export const countLeapYears = (year: number) => {
  const currentYear = new Date().getFullYear();
  let beginYear = 0,
    endYear = 0,
    leapYearCount = 0;
  if (currentYear < year) {
    beginYear = currentYear;
    endYear = year;
  } else if (currentYear > year) {
    beginYear = year;
    endYear = currentYear;
  } else if (currentYear == year) {
    beginYear = year;
    endYear = year;
  }
  for (let i = beginYear; i <= endYear; i++) {
    if ((i % 4 == 0 && i % 100 != 0) || i % 400 == 0) leapYearCount++;
  }
  return leapYearCount;
};

export const checkBirthdayMajority = (eligibleAge: number, dateOfBirth?: Date): boolean => {
  const eligibleDate = new Date();
  eligibleDate.setFullYear(new Date().getFullYear() - eligibleAge);
  if (dateOfBirth) return dateOfBirth <= eligibleDate;
  return false;
};

export const checkDateIsInTimeInterval = (date?: Date): boolean => {
  const dateRefLow = new Date('Mon Jan 1,1900').getTime();
  const dateRefHigh = Date.now();
  if (date) return date.getTime() >= dateRefLow && date.getTime() < dateRefHigh;
  return false;
};

export const checkDateFullfilled = (value: string): boolean => {
  if (value) return value.length === 10;
  return false;
};

export const checkYearDateFullfilled = (value: string) => {
  if (value) return value.length === 4;
  return false;
};

export const checkFuturDate = (date: string) => {
  if (date) return new Date(date).getTime() < Date.now();
  return false;
};

export const checkNewerThanBirthdayYear = (dateOfBirth?: string, dateCompare?: string) => {
  const newDate = new Date(dateCompare as string);
  if (!dateOfBirth) return false;
  const birthDateInput = dateOfBirth.split('/');
  const finalBirthDate = `${birthDateInput[1]}/${birthDateInput[0]}/${birthDateInput[2]}`;
  return (
    newDate.getFullYear() >= new Date(finalBirthDate).getFullYear() ||
    newDate.getTime() > new Date(finalBirthDate).getTime()
  );
};
